import { CreatorBrand } from 'constants/brands';
import React from 'react';
import { Modal, ButtonGroup, Paragraph, Button } from '@landr/maestro';
import { Trans } from '@lingui/macro';
import { useCreatorContext } from 'controllers/business/Creator/Creator.controller';
import RemoveFromCreatorButton from 'components/Creator/RemoveFromCreatorButton';

export const ConfirmRemoveAllModal: React.FC = () => {
    const { state: creatorState, closeRemoveAllModal } = useCreatorContext();

    return (
        <Modal
            isOpen={creatorState.isRemoveAllModalOpen}
            onClose={closeRemoveAllModal}
        >
            <Modal.Header>
                <Modal.Title>
                    <Trans>Delete all samples?</Trans>
                </Modal.Title>
            </Modal.Header>
            <Modal.Content>
                <Modal.Section>
                    <Paragraph>
                        <Trans>
                            You’re about to delete all sounds from{' '}
                            {CreatorBrand}. Are you sure?
                        </Trans>
                    </Paragraph>
                </Modal.Section>
            </Modal.Content>
            <Modal.Footer>
                <ButtonGroup>
                    <Button
                        kind="minimal"
                        variant="secondary"
                        onClick={closeRemoveAllModal}
                    >
                        <Trans>Back</Trans>
                    </Button>

                    <RemoveFromCreatorButton variant="danger" kind="solid">
                        <Trans>Delete</Trans>
                    </RemoveFromCreatorButton>
                </ButtonGroup>
            </Modal.Footer>
        </Modal>
    );
};

export default ConfirmRemoveAllModal;
